let state = {
    all:             [],
    cachedAll:       [],
    persons:         {},
    statuses:        [],
    groups:          [],
    ghostGroup:      {},
    fullDayAbsences: {},
    partDayAbsences: {},
    weekSchedules:   {},
    updated:         null,
    draggingGroup:   null,
    canBeManaged:    false
};

export default state;